export const buildFilterDisplayValues = (translate) => {

  return {
    trigger: [
      {
        displayName: translate("filters-display.Manual"),
        value: "Manual",
        selectable: true,
      },
      {
        displayName: translate("filters-display.Schedule"),
        value: "Schedule",
        selectable: true,
      },
    ],
  };
};
